import { lang } from 'moment';
import React from 'react';
import { useState, useRef } from 'react';
import { FaPlay, FaPause, FaUpload, FaDownload } from 'react-icons/fa';


const sample = {
	id: '2b1b78fd3dfb5dfd75e1682362394661',
	name: '6192.wav',
	language: ['english', 'spanish'],
	type: 'system',
	lastUpdatedUser: 'System',
	lastUpdatedDate: 'April 24, 2023',
	tts: {
		english: 'Hello, this is a test',
		spanish: 'Hola, esto es una prueba'
	},
	url: {
		english: 'https://85d1-74-70-176-142.ngrok-free.app/english/6192.wav',
		spanish: 'https://85d1-74-70-176-142.ngrok-free.app/spanish/6192.wav'
	}
}
const languageCodes = {
	english: { code: 'EN', color: 'darkblue' },
	spanish: { code: 'ES', color: 'darkgreen' },
	french: { code: 'FR', color: 'purple' },
	german: { code: 'DE', color: 'orange' },
	italian: { code: 'IT', color: 'red' },
	portuguese: { code: 'PT', color: 'brown' },
	russian: { code: 'RU', color: 'black' },
	mandarin: { code: 'ZH', color: 'brown' },
	japanese: { code: 'JA', color: 'pink' },
	arabic: { code: 'AR', color: 'gray' },
	hebrew: { code: 'HE', color: 'blue' },
	haitian: { code: 'HT', color: 'green' },
	korean: { code: 'KO', color: 'violet' },
	bengali: { code: 'BN', color: 'orange' },
	romanian: { code: 'RO', color: 'lightorange' },
	serbian: { code: 'SR', color: 'lightred' },
	turkish: { code: 'TR', color: 'lightbrown' },
	ukrainian: { code: 'UK', color: 'lightblack' },
	vietnamese: { code: 'VI', color: 'lightyellow' },
	cantonese: { code: 'YUE', color: 'teal' }, // Added
	urdu: { code: 'UR', color: 'lightblue' },  // Added
	polish: { code: 'PL', color: 'lightgreen' } // Added
};

export default class promptManager extends React.PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			clickedButtons: {},
			upload: false,
			text: '',
			audioUrl: '',
			prompt: this.props.prompt,
			playingTTS: false
		};
	}



	handleClick = (lang) => {
		this.setState(prevState => ({
			clickedButtons: {
				...prevState.clickedButtons,
				[lang]: true
			}
		}));
	};

	handleFileUpload = (event) => {
		const file = event.target.files[0];
		const reader = new FileReader();
		reader.onload = (event) => {
			const dataUrl = event.target.result;
			this.setState(prevState => {
				const { prompt, language } = prevState;
				const updatedUrl = { ...prompt.url, [language]: dataUrl };
				const updatedTTS = { ...prompt.tts, [language]: false };
				const updatedPrompt = { ...prompt, url: updatedUrl, tts: updatedTTS };
				console.log(updatedPrompt);
				return { file, prompt: updatedPrompt, upload: false, };
			});
		};
		reader.readAsDataURL(file);
	};

	previewSpeech = async () => {
		const id = uuidv4();
		try {
			this.props.ws.send(JSON.stringify({ route: 'getTTS', tts: { text: this.state.text, id: id, language: this.state.language } }));

			this.props.ws.addEventListener('message', (event) => {
				const data = JSON.parse(event.data);
				if (data.route === id) {
					//Remove the listener
					this.props.ws.removeEventListener('message', this);

					const audioDataUrl = `data:audio/wav;base64,${data.file}`;
					//const audioDataUrl = data.file;

					// Create an Audio object and play the audio
					const audio = new Audio(audioDataUrl);
					//set state to playing
					this.setState({ playingTTS: true });

					audio.play().finally(() => { this.setState({ playingTTS: false }); });
				}
			});


		} catch (error) {
			console.error(error);
		}
	};

	createTTSPrompt = async () => {
		try {
			//Generate a unique ID for the prompt
			const id = uuidv4();

			this.props.ws.send(JSON.stringify({ route: 'getTTS', tts: { text: (this.state.text) ? this.state.text : " ", id: id, language: this.state.language } }));

			this.props.ws.addEventListener('message', (event) => {
				const data = JSON.parse(event.data);
				if (data.route === id) {
					//Remove the listener
					this.props.ws.removeEventListener('message', this);

					this.setState(prevState => {
						const { prompt, language } = prevState;
						const updatedUrl = { ...prompt.url, [language]: `data:audio/wav;base64,${data.file}` };
						const updatedTTS = { ...prompt.tts, [language]: this.state.text };
						const updatedPrompt = { ...prompt, url: updatedUrl, tts: updatedTTS };
						return { prompt: updatedPrompt, upload: false };
					});
				}
			})
			//Send a unique ID to the server to identify the prompt


		} catch (error) {
		}
	};
	handleInternalCancel = () => {
		this.setState({ upload: false });
	};

	confirmEditPrompt = async () => {
		try {

			this.props.ws.send(JSON.stringify({ route: 'editPrompt', prompt: this.state.prompt }));
			this.props.cancel();
		} catch (error) {
			console.error(error);
		}
	};

	confirmDeletePrompt = async () => {
		try {

			this.props.ws.send(JSON.stringify({ route: 'deletePrompt', prompt: this.state.prompt }));
			this.props.cancel();
		} catch (error) {
			console.error(error);
		}
	};

	confirmRevertPrompt = async () => {
		try {

			this.props.ws.send(JSON.stringify({ route: 'revertPrompt', prompt: this.state.prompt }));
			this.props.cancel();
		} catch (error) {
			console.error(error);
		}
	};

	handleTextChange = (event) => {
		this.setState({ text: event.target.value });
	};
	toggleFileSection = (type, language) => {
		console.log("Top")
		console.log(language)
		var tempText = ""
		if (type === "TTS") {
			tempText = this.state.prompt.tts[language]
		}
		this.setState({ upload: type, language: language, text: tempText })
	}
	handleNameChange = (event) => {
		console.log(event.target)
		var char = event.target.value
		//console.log(event.target.value)
		this.setState(prevState => {
			const { prompt } = prevState;
			const updatedPrompt = { ...prompt, name: char };
			return { prompt: updatedPrompt };
		});
	};
	handleHover = (event) => {
		console.log("Hover")
		const lang = event.target.getAttribute('data-lang'); // Get the language from the data-lang attribute
		console.log(lang)
		this.setState({ [`previewText_${lang}`]: true });
	};

	handleHoverExit = (event) => {
		console.log("Exit")
		const lang = event.target.getAttribute('data-lang'); // Get the language from the data-lang attribute
		console.log(lang)
		this.setState({ [`previewText_${lang}`]: false });
	};

	render() {

		var data = this.props.data
		console.log(data)
		var prompt = this.state.prompt
		if (!prompt) {

			prompt = {
				name: '',
				language: [],
				type: 'custom',
				url: {},
				tts: {}
			}
			this.state.prompt = prompt
			//this.props.prompt = prompt
		}
		var languages = []
		const languagesHoverState = {};
		for (var language of data.settings.language) {
			if (prompt.url[language]) {
				console.log("Has url for " + language)
				console.log(prompt.url[language])
				// Inside your render method	
				var lang = language;
				var text = (prompt.tts) ? prompt.tts[language] : "";

				languages.push((
					<React.Fragment key={language}>
						<div style={{ backgroundColor: '#f2f2f2', padding: '15px', borderRadius: '5px', width: '300px' }}>
							<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', marginBottom: '5px', marginTop: '1px' }}>
								<div style={{ backgroundColor: languageCodes[language].color, color: '#fff', fontWeight: 'bold', fontSize: '16px', padding: '5px 10px', borderRadius: '5px', marginBottom: '5px' }}>{lang.charAt(0).toUpperCase() + lang.slice(1)}</div>
								{text && (
									<div
										style={{
											display: 'flex',
											alignItems: 'center',
										}}
										onMouseEnter={this.handleHover}
										onMouseLeave={this.handleHoverExit}
										data-lang={language}
									>
										<div
											style={{
												backgroundColor: languageCodes[language].color,
												color: '#fff',
												fontSize: '14px',
												padding: '3px 8px',
												marginLeft: '5px',
												borderRadius: '5px',
												cursor: 'pointer',
												marginRight: '5px',
											}}
											data-lang={language}
										>
											TTS
											{this.state[`previewText_${language}`] && (
												<div
													style={{
														position: 'absolute',
														backgroundColor: 'rgba(0, 0, 0, 0.8)',
														color: '#fff',
														padding: '5px',
														borderRadius: '5px',
														zIndex: 999,
														width: '200px'
													}}
													data-lang={language}
												>
													{text}
												</div>
											)}
										</div>
									</div>
								)}
							</div>
							<PlayButton fileUrl={prompt.url[lang]} toggleFileSection={this.toggleFileSection} language={lang} />
						</div>
						<br />
					</React.Fragment>
				))


			}
			else {
				console.log("No url for " + language)
				var lang = language
				languages.push((
					<React.Fragment key={language}>
						<div style={{ backgroundColor: '#f2f2f2', padding: '15px', borderRadius: '5px', width: '300px' }}>
							<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '5px', marginTop: '1px' }}>
								<div style={{ backgroundColor: languageCodes[language].color, color: '#fff', fontWeight: 'bold', fontSize: '16px', padding: '5px 10px', borderRadius: '5px', marginBottom: '5px' }}>{lang.charAt(0).toUpperCase() + lang.slice(1)}</div>
								<UploadIcon toggleFileSection={this.toggleFileSection} language={lang} />
							</div>
							<p style={{ fontWeight: 'bold', fontSize: '14px', color: '#9b9b9b' }}>No prompt available. Click the upload Icon.</p>
						</div>
						<br />
					</React.Fragment>
				))
			}


		}


		if (!this.state.upload) {
			if (prompt.type == "system" || prompt.type == "special") {
				return (

					<div className="pop" style={{ zIndex: 1 }}>
						<div className="viewCloser" onClick={this.props.cancel}></div>
						{prompt.type == "system" && <h3>{"System Prompt: " + prompt.name}</h3>}
						{prompt.type == "special" && <h3>{"Special Prompt: " + prompt.name}</h3>}
						{languages}

						<div style={{ display: 'flex', justifyContent: 'space-between' }}>
							<div className="button confirm" onClick={this.confirmEditPrompt} title="Confirm Changes">
								Confirm
							</div>
							<div className="button revert" onClick={this.confirmRevertPrompt} style={{ backgroundColor: '#c0392b' }} title="Replace any of the changes with the original IVR Prompts">
								Revert
							</div>
						</div>
						<div style={{ paddingTop: '25px', display: 'flex', justifyContent: 'space-around' }}></div>
					</div>



				)
			} else {
				return (
					<div className="pop" style={{ zIndex: 1 }}>
						<div className="viewCloser" onClick={this.props.cancel}></div>
						<div className="snazzyInputBox">
							<input
								className="textInput"
								type="text"
								required
								value={this.state.prompt.name}
								onChange={this.handleNameChange}
							></input>
							<span className="inputBar"></span>
							<label className="textLabel">Name</label>
						</div>
						{languages}
						<div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
							<div className="button confirm" onClick={this.confirmEditPrompt} title="Confirm Changes">
								Confirm
							</div>
							<div className="button delete" onClick={this.confirmDeletePrompt} style={{ backgroundColor: '#c0392b' }} title="Delete this IVR Prompt">
								Delete
							</div>
						</div>
					</div>
				)
			}
		} else {
			switch (this.state.upload) {
				case "TTS":



					return (
						<div className="pop" style={{ zIndex: 1 }}>
							<div className="viewCloser" onClick={this.handleInternalCancel}></div>
							<h3 style={{ textAlign: "center" }}>{"Text to Speech"}</h3>
							<div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "16px" }}>
								<textarea style={{ fontSize: "18px", width: "250px", height: "200px" }} placeholder="Enter text to convert to speech" onChange={this.handleTextChange} value={this.state.text} />
								<div style={{ display: "flex", gap: "16px" }}>
									<button className="button confirm" style={{ fontSize: "18px", padding: "12px", border: "none", backgroundColor: !this.state.text ? "#ccc" : "", color: !this.state.text ? "#666" : "#fff", cursor: !this.state.text ? "not-allowed" : "pointer" }} onClick={this.previewSpeech} disabled={this.state.text === ""}>
										{this.state.playingTTS ? "Stop" : "Preview"}
									</button>
									<button className="button confirm" style={{ fontSize: "18px", padding: "12px", border: "none", color: "#fff", cursor: "pointer" }} onClick={this.createTTSPrompt} disabled={false}>
										Confirm
									</button>
								</div>
							</div>
						</div>
					);
				case "Phone Call":
					return (
						<div className="pop" style={{ zIndex: 1 }}>
							<div className="viewCloser" onClick={this.handleInternalCancel}></div>
							<h3>{"Phone Call"}</h3>
						</div>
					)
					break;
				default:
					return (
						<div className="pop" style={{ zIndex: 1, padding: '30px 40px' }}>
							<div className="viewCloser" onClick={this.handleInternalCancel}></div>
							<h2 style={{ marginTop: 0 }}>{"File Upload"}</h2>
							<label htmlFor="file-upload" className="button confirm" title="Choose File" style={{ fontSize: "20px", padding: '10px 15px' }} >
								Choose File
							</label>
							<input id="file-upload" type="file" onChange={this.handleFileUpload} style={{ display: "none", fontSize: "14px" }} />
						</div>
					)
					break;
			}

		}

	}
}


const PlayButton = ({ fileUrl, toggleFileSection, language }) => {
	const audioRef = useRef();
	const [isPlaying, setIsPlaying] = useState(false);
	const [currentTime, setCurrentTime] = useState(0);
	const [duration, setDuration] = useState(0);

	const togglePlay = () => {
		if (isPlaying) {
			audioRef.current.pause();
		} else {
			audioRef.current.play();
		}
		setIsPlaying(!isPlaying);
	};
	const handleTimeUpdate = () => {
		setCurrentTime(audioRef.current.currentTime);
	};
	const handleLoadedData = () => {
		setDuration(audioRef.current.duration);
	};

	const containerStyle = {
		display: 'flex',
		alignItems: 'center',
		width: '300px',
	};

	const progressBarContainerStyle = {
		display: 'flex',
		alignItems: 'center',
		flex: '1',
		marginLeft: '10px',
		marginRight: '10px',
		position: 'relative',
		justifyContent: 'space-between',
	};

	const progressBarStyle = {
		flex: '1',
		height: '4px',
		backgroundColor: languageCodes[language].color,
		position: 'relative',
	};

	const progressBarHandleStyle = {
		content: '',
		display: 'block',
		position: 'absolute',
		top: '-3px',
		left: `${(currentTime / duration) * 100}%`,
		backgroundColor: '#fff',
		height: '10px',
		width: '10px',
		borderRadius: '50%',
		boxShadow: '0 0 4px #000',
		transform: 'translateX(-50%)',
	};

	const buttonStyle = {
		border: 'none',
		background: 'none',
		cursor: 'pointer',
		outline: 'none',
	};

	const playButtonStyle = {
		color: languageCodes[language].color,
		fontSize: '24px',
		padding: '0',
		marginRight: '10px',
	};
	const downloadButtonStyle = {
		color: languageCodes[language].color,
		fontSize: '24px',
		padding: '0',
		marginLeft: '10px',
		transition: 'color 0.3s ease',
	};
	const handleDownload = (url) => {
		//Download file without opening new tab
		window.open(url, '_blank');
	}
	const handleUpload = (type) => {
		console.log("Yo")
		console.log("play button")
		console.log(language)
		console.log(type)
		toggleFileSection(type, language);
	}


	return (
		<div style={containerStyle}>
			<button style={{ ...buttonStyle, ...playButtonStyle }} onClick={togglePlay}>
				{isPlaying ? <FaPause /> : <FaPlay />}
			</button>
			<div style={progressBarContainerStyle}>
				<div style={progressBarStyle}>
					<span style={progressBarHandleStyle}></span>
				</div>
				<UploadIcon toggleFileSection={handleUpload} language={language} />

				<button style={{ ...buttonStyle, ...downloadButtonStyle }} title="Download Prompt" onClick={() => { handleDownload(fileUrl) }}>
					<FaDownload />
				</button>
			</div>
			<audio
				ref={audioRef}
				src={fileUrl}
				onTimeUpdate={handleTimeUpdate}
				onLoadedData={handleLoadedData}
			/>
		</div>
	);
};


function UploadIcon({ toggleFileSection, language }) {
	const [showMenu, setShowMenu] = useState(false);

	const handleIconClick = () => {
		setShowMenu(!showMenu);
	};

	const handleOptionClick = (type) => {


		toggleFileSection(type, language);
		// execute empty function
	};
	const iconStyle = {
		color: languageCodes[language].color,
		fontSize: '24px',
		padding: '0',
		marginLeft: '20px',
		transition: 'color 0.3s ease',
	};

	const menuStyle = {
		position: 'absolute',
		top: 'calc(100% + 5px)',
		left: '50%',
		transform: 'translateX(-50%)',
		zIndex: '1',
		display: 'flex',
		flexDirection: 'column',
		width: '120px',
		padding: '8px',
		backgroundColor: '#fff',
		borderRadius: '5px',
		boxShadow: '0 2px 5px rgba(0, 0, 0, 0.3)',
	};

	const optionStyle = {
		padding: '8px 0',
		textAlign: 'center',
		fontSize: '14px',
		color: '#333',
		cursor: 'pointer',
		borderTop: '1px solid #ccc',
	};

	return (
		<div style={{ position: 'relative', display: 'inline-block' }}>
			<div style={iconStyle} onClick={handleIconClick} title="Upload Prompt">
				<FaUpload />
			</div>
			{showMenu && (
				<div style={menuStyle}>
					<div style={optionStyle} onMouseOver={(e) => e.target.style.backgroundColor = '#2A6AA9'} onMouseOut={(e) => e.target.style.backgroundColor = '#fff'} onClick={() => { handleOptionClick("TTS") }}>TTS</div>
					<div style={optionStyle} onMouseOver={(e) => e.target.style.backgroundColor = '#2A6AA9'} onMouseOut={(e) => e.target.style.backgroundColor = '#fff'} onClick={() => { handleOptionClick("Upload") }}>Upload</div>
				</div>
			)}
		</div>
	);
}

function uuidv4() {
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
		// eslint-disable-next-line
		var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
		// eslint-disable-next-line
		return v.toString(16);
	});
};


